import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import { ChevronLeft, ChevronRight } from "lucide-react";
import departmentOfForeignAffairsAndTrade from "./images/department_of_Foreign_Affairs_and_Trade.png";
import iitKanpur from "./images/iitk-logo-removebg-preview.png";
import c3ihub from "./images/c3ihub.svg";
import UniversityOfWollongong from "./images/AwPg4oj4iuSCnTCkgFvZ2-transformed.webp";

const OurSponsors = () => {
    const data = [
        { name: "Department of Foreign Affairs and Trade", image: departmentOfForeignAffairsAndTrade },
        { name: "IIT Kanpur", image: iitKanpur },
        { name: "C3iHub IITK", image: c3ihub },
        { name: "University of Wollongong", image: UniversityOfWollongong },
    ];

    const [currentIndex, setCurrentIndex] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);

    const nextSlide = () => {
        if (!isAnimating) {
            setIsAnimating(true);
            setCurrentIndex((prevIndex) => (prevIndex + 1) % (data.length - itemsPerSlide + 1));
        }
    };

    const prevSlide = () => {
        if (!isAnimating) {
            setIsAnimating(true);
            setCurrentIndex((prevIndex) => (prevIndex - 1 + data.length - itemsPerSlide + 1) % (data.length - itemsPerSlide + 1));
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsAnimating(false);
        }, 500);

        return () => clearTimeout(timer);
    }, [currentIndex]);

    useEffect(() => {
        const interval = setInterval(nextSlide, 5000);
        return () => clearInterval(interval);
    }, []);

    const itemsPerSlide = window.innerWidth >= 1024 ? 4 : window.innerWidth >= 640 ? 2 : 1;

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8">
            <h2 className="heading">Our Sponsors</h2>

            {/* <div className="grid grid-cols-1 md:grid-cols-4 gap-5"> */}
            <div className="relative overflow-hidden rounded-lg pb-6 pt-3 ">
                <div
                    className="flex transition-transform duration-500 ease-in-out"
                    style={{
                        transform: `translateX(-${currentIndex * (100 / itemsPerSlide)}%)`,
                    }}
                >
                    {data.map((sponsor, index) => (
                        <div key={index} className="w-full sm:w-1/2 lg:w-1/4 flex-shrink-0 px-3">
                            <div className="bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 flex flex-col items-center justify-center h-full transform hover:-translate-y-1">
                                <img src={sponsor.image} alt={`${sponsor.name} logo`} className="h-24 object-contain mb-4 filter drop-shadow-md transition-transform duration-300 hover:scale-105" />
                                <h3 className="text-xl font-semibold text-gray-800 text-center">{sponsor.name}</h3>
                            </div>
                        </div>
                    ))}
                </div>

                <button
                    onClick={prevSlide}
                    className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-3 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition duration-300 shadow-lg"
                    aria-label="Previous sponsor"
                >
                    <ChevronLeft className="w-6 h-6 text-gray-700" />
                </button>
                <button
                    onClick={nextSlide}
                    className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-3 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition duration-300 shadow-lg"
                    aria-label="Next sponsor"
                >
                    <ChevronRight className="w-6 h-6 text-gray-700" />
                </button>
            </div>

            <div className="flex justify-center mt-6">
                {data.slice(0, data.length - itemsPerSlide + 1).map((_, index) => (
                    <button
                        key={index}
                        onClick={() => setCurrentIndex(index)}
                        className={`h-3 w-3 rounded-full mx-1 focus:outline-none transition-all duration-300 ${index === currentIndex ? "bg-indigo-600 w-6" : "bg-gray-300 hover:bg-indigo-400"}`}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>
        </div>
        // </div>
    );
};

export default OurSponsors;
